import { types } from "../action-types";
import moment from "moment";
const profile = JSON.parse(localStorage.getItem("userProfile"));
const initialState = {
  inboxLoading: false,
  sentItemsLoading: false,
  sendMessageLoading: false,
  inbox: { data: { data: { body: { conversations: [] } } } },
  sentItems: [],
  makeLoading: false,
  inboxError: {},
  sentItemsError: {},
  sendMessageError: {},
  historyLoading: false,
  chats: [],
  notification: [],
  bidStatus: [],
  error: false,
  Hrms: [],
  uploadFileRes: "",
  editOfferRes: false,
  editOfferLoading: false,
  makeOfferRes: false,
  hasMorechats: true,
  jobDetail: [],
  page: 3,
  counts: {},
  newMsgInSocket: false,
  pageNo: [],
  sendMessageLoading:false,
  conversationUnreadCount:0,
  flag:false
};

const messagesReducer = (state = initialState, action) => {
  switch (action.type) {

    case types.GET_CONVERSATION_COUNT_INIT:
      return {
        ...state,
        conversationCountLoading:true,
      };
    case types.GET_CONVERSATION_COUNT_SUCCESS:
      return {
        ...state,
        conversationCount : action.payload?.data?.data?.body?.Total,
        conversationUnreadCount:action.payload?.data?.data?.body?.Unread,
        conversationCountLoading:false,
      };
    case types.GET_CONVERSATION_COUNT_FAILURE:
      return {
        ...state,
        conversationCountLoading:false,
      };


    case types.FETCH_MESSAGES_REQUESTED:
      return {
        ...state,
        inboxLoading:
          action.payload.type === "inbox" ? true : state.inboxLoading,
        sentItemsLoading:
          action.payload.type === "sentItems" ? true : state.sentItemsLoading,
      };

    case types.FETCH_MESSAGES_SUCCESS:
      return {
        ...state,
        inboxLoading: false,
          // action.payload.type === "inbox" ? false : state.inboxLoading,
        sentItemsLoading:
          action.payload.type === "sentItems" ? false : state.sentItemsLoading,
        inbox: [
          ...(action.payload.type === "inbox"
            ? action.payload.data
            : state.inbox),
        ],
        sentItems: [
          ...(action.payload.type === "sentItems"
            ? action.payload.data
            : state.sentItems),
        ],
      };
    case types.FETCH_MESSAGES_FAILURE:
      return {
        ...state,
        loading: false,
        sentItems: action.payload.type === "sentItems" ? [] : state.sentItems,
        inbox: action.payload.type === "inbox" ? [] : state.inbox,
        sentItemsError:
          action.payload.type === "sentItems"
            ? action.payload.error
            : state.sentItemsError,
        inboxError:
          action.payload.type === "inbox"
            ? action.payload.error
            : state.inboxError,
      };
    case types.SEND_MESSAGE_REQUESTED:
      return {
        ...state,
        sendMessageLoading: true,
        sendMessageError: {},
      };

    case types.SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        sendMessageLoading: false,
        sendMessageError: {},
      };
    case types.GET_HRM_SUCCESS:
      return {
        ...state,
        Hrms: [action.profile,...action.payload],
      };
    case types.SEND_MESSAGE_FAILURE:
      return {
        ...state,
        sendMessageLoading: false,
        sendMessageError: action.error,
      };
    case types.GET_MESSAGES_INBOX_REQUESTED:
      if (action.payload.filter) {
        return {
          ...state,
          inboxLoading: true,
          inbox: { data: { data: { body: { conversations: [] } } } },
          page: 3
        };
      }
      if(action.payload.page === 2) {
        return {
          ...state,
          page: 3
        }
      }
      return {
        ...state,
        inboxLoading: true,
        // inbox: { data: { data: { body: { conversations: [] } } } },
      };
    case types.GET_MESSAGES_INBOX_SUCCESS:
      let conversationData = action?.payload?.data?.data?.body?.conversations;
      let inboxData = state?.inbox?.data?.data?.body?.conversations;
      // if (action.payload.fromSocket) {
      //   inboxData = state?.inbox?.data?.data?.body?.conversations.filter(
      //     (convo) => convo?._id !== conversationData[0]?._id
      //   );
      // } else {
      //   inboxData =
      //     conversationData && conversationData.length > 0
      //       ? state?.inbox?.data?.data?.body?.conversations.filter(
      //           (convo, index) => convo?._id !== conversationData[index]?._id
      //         )
      //       : [];
      // }
      let conversations = [...inboxData, ...conversationData].reverse();
      conversations = [...new Set(conversations.map(item => item._id))].map(id => {
        return conversations.find(item => item._id === id)
      })

      //  let conversations = []
      // if(inboxData.length > 0 ) {
      //   conversations = [...inboxData, ...conversationData]
      // }
      // else{
      //   conversations = conversationData
      // }
      let tempPage = state.page   
      if(action?.payload?.fetchMore) tempPage = tempPage + 1
      conversations.sort((a, b) => moment(b.Created) - moment(a.Created));
      return {
        ...state,
        inbox: {
          ...state?.inbox,
          data: {
            ...state?.inbox?.data,
            data: {
              ...state?.inbox?.data?.data,
              body: {
                ...state?.inbox?.data?.data?.body,
                conversations: conversations,
                // [...inboxData,//...state?.inbox?.data?.data?.body?.conversations
                // ...conversationData]
              },
            },
          },
        },
        page: tempPage,
        hasMorechats:
          action.payload.data.data.body.conversations.length > 0
            ? true
            : false,
        newMsgInSocket: action.payload.fromSocket,
        pageNo: [...state.pageNo, action.payload.pageNumber],
        inboxLoading: false,
      };
    case types.GET_MESSAGES_INBOX_FAILURE:
      return {
        ...state,
        inbox: "no messages found",
        inboxLoading: false,
      };
      case types.RESET_CHAT_REDUCER:
      return {
        ...state,
        chats:null
      };
    case types.FETCH_CHAT_REQUESTED:
      return {
        ...state,
        historyLoading: true,
        bidStatus: [],
      };
    case types.FETCH_CHAT_SUCCESS:
      return {
        ...state,
        historyLoading: false,
        chats: action.payload,
        error: false,
        bidStatus: action.payload.data.body.map((items) => {
          return items.Status;
        }),
      };
    case types.MESSAGE_RECEIVED:
      const data = action?.payload?.message?.data;
      // bidStatus:
      //  inboxData?.map((items) => {
      //   return items.Status;
      // })
      // state.chats[0]?.data?.body?.conversationId === action?.payload?.message?.data?.conversationId ?
      if (state.chats?.data?.body[0]?.ConversationId === data?.ConversationId && state.chats?.data?.body[0]?.ConversationId && data?.ConversationId ) {
        if (action.payload.message.edited) {
          let messages = [...state.chats.data.body];
          const index = messages.findIndex(
            (obj) => obj._id == action.payload.message.data._id
          );
          messages[index] = action?.payload?.message?.data?.isFromReadMessage ? {...messages[index],ReadAt:action.payload.message.data.ReadAt} : action.payload.message.data;
          return {
            ...state,
            flag: !state.flag,
            chats: {
              data: {
                body: messages,
              },
            },
          };
        } else {
          return {
            ...state,
            chats: {
              data: {
                body: [//can put new set here
                  ...state?.chats?.data?.body,
                  action.payload.message.data,
                  // filterData,
                ],
              },
            },
            bidStatus: [...state.bidStatus, data.Status],
            notification: action.payload,
          };
        }
      } else {
        return { ...state };
      }
    
    case types.MESSAGE_RECEIVED_INIT:
      return {
        ...state,
        sendMessageLoading:true
      };
      
    case types.MESSAGE_RECEIVED_SUCCESS:
      return {
        ...state,
        sendMessageLoading:false
      };
      
    case types.MESSAGE_RECEIVED_FAILURE:
      return {
        ...state,
        sendMessageLoading:false
      };
      

    case types.SEND_MESSAGE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        uploadFileRes: action.payload,
      };
    case types.EDIT_OFFER_REQUESTED:
      return {
        ...state,
        editOfferLoading: action.payload.data.loading,
        editOfferRes: false,
      };
    case types.EDIT_OFFER_SUCCESS:
      return {
        ...state,
        editOfferLoading: false,
        editOfferRes: action.payload,
      };
    case types.CLEAR_EDIT_OFFER_RESPONSE:
      return{
        ...state,
        editOfferRes: false
      }

    case types.POST_OFFER_REQUESTED:
      return {
        ...state,
        makeLoading: true,
        makeOfferRes: false,
      };
    case types.POST_OFFER_SUCCESS:
      return {
        ...state,
        makeLoading: false,
        makeOfferRes: true,
      };
    case types.GET_INBOX_JOB_DETAILS:
      return {
        ...state,
        jobDetail: action.payload,
      };
    case types.GET_MESSAGES_COUNTS_SUCCESS:
      return {
        ...state,
        counts: action.payload,
      };
      case types.FAVOURITE_SUCCESS: {
        let favIndex = action.payload;
        let oldChat = state?.inbox?.data?.data?.body?.conversations;
  
  
  
        // console.log('updated>> oldChat',oldChat)
        // let updatedChat = oldChat?.map((item,index)=>{
        //   if(index == favIndex){
        //     item.IsFavorite = true;
        //   }
        // })
        if(oldChat[favIndex]){
          oldChat[favIndex].IsFavorite = true;
        }
        let updatedChat = oldChat
        // oldChat.IsFavorite = true;
        return {
          ...state,
          inbox: {
            ...state?.inbox,
            data: {
              ...state?.inbox?.data,
              data: {
                ...state?.inbox?.data?.data,
                body: {
                  ...state?.inbox?.data?.data?.body,
                  conversations: updatedChat,
                },
              },
            },
          },
        };
      }
      
      case types.REMOVE_FAV_SUCCESS: {
        let favIndex = action.payload;
        let oldChat = state?.inbox?.data?.data?.body?.conversations;
        // let updatedChat = oldChat?.map((item,index)=>{
        //   if(index == favIndex){
        //     item.IsFavorite = true;
        //   }
        // })
        oldChat[favIndex].IsFavorite = false;
  
        let updatedChat = oldChat
        // console.log('REMOVE_FAV_SUCCESS red>> updatedChat >>',action.payload,updatedChat)
        // oldChat.IsFavorite = true;
        // const
        return {
          ...state,
          inbox: {
            ...state?.inbox,
            data: {
              ...state?.inbox?.data,
              data: {
                ...state?.inbox?.data?.data,
                body: {
                  ...state?.inbox?.data?.data?.body,
                  conversations: updatedChat,
                },
              },
            },
          },
        };
      }
      case types.MARK_MESSAGE_AS_READ:
        let newConversationUnreadCount = state.conversationUnreadCount;
        if (state.inbox?.data?.data?.body?.conversations) {
          state.inbox.data.data.body.conversations.forEach(convo => {
            if (convo?._id === action?.payload && convo?.countUnRead > 0) {
              newConversationUnreadCount = state.conversationUnreadCount - 1;
            }
          });
        }
        return {
          ...state,
          conversationUnreadCount: newConversationUnreadCount > 0 ? newConversationUnreadCount : 0,
        };
      
    default:
      return state;
  }
};

export default messagesReducer;
